import {reqWithToken} from './requestHelper';

export async function getFormsHistory(){
    return (await reqWithToken('api/gxbooking/history')).data;
}